/**
 * theboer.co.za / boer.metaship.ai public landing is a TenantApp custom HTML
 * document (loginPage.mode === "custom"), not the signed-in Boer MFE.
 * The uploaded file lives on the tenant-apps CDN with no CORS headers, so the
 * shell cannot fetch-and-rewrite it. Boer tenants therefore render the
 * bundled landing from `landing-pages/boer.html` via srcdoc.
 *
 * fuel.theboer.co.za (BOE-153) is the Fuel app: it sits under theboer.co.za but is a signed-in product with its
 * own login, never the Boer marketing page — that host is excluded before anything else is looked at.
 */
const FUEL_HOST = "fuel.theboer.co.za";

export function isBoerMarketingLanding(opts: {
  slug?: string | null;
  htmlUrl?: string | null;
  hostname?: string | null;
}): boolean {
  const host = (opts.hostname || "").trim().toLowerCase();
  if (host === FUEL_HOST) return false;

  const slug = (opts.slug || "").trim().toLowerCase();
  if (slug === "boer-za" || slug === "boer") return true;

  if (host === "theboer.co.za" || host.endsWith(".theboer.co.za") || host === "boer.metaship.ai") {
    return true;
  }

  const url = opts.htmlUrl || "";
  // Live upload as of 2026-08-31 (GET /tenant-apps/resolve?host=theboer.co.za).
  if (url.includes("login-1788152285185.html")) return true;
  return false;
}
